import styled from 'styled-components';

export default styled.div`
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  .input {
    display: grid;
    grid-gap: 5px;
    grid-template-columns: 1fr auto;
    align-items: center;
  }
`;
